import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1t2tge9kwv: FaireBrandEntity = {
  token: "b_1t2tge9kwv",
  type: "brand",
  name: "Naturelab. TOKYO",
  avatarUrl:
    "https://cdn.faire.com/fastly/e55f0b0ca979098e1dc4f055af8d246679c0069e7da9f7f5870bd85c31f84aa8.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/af529d3485eaf0b49fa7496195bf7d9059adf95376d5555450dd09de1954473d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e55f0b0ca979098e1dc4f055af8d246679c0069e7da9f7f5870bd85c31f84aa8.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/af529d3485eaf0b49fa7496195bf7d9059adf95376d5555450dd09de1954473d.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 200,
  rating: 4.5,
  reviewCount: 4,
  isInsider: true,
  description:
    "Powered by Plants. Perfected by Science. Proven by You. NatureLab. TOKYO blends the rich heritage of Japan with cutting-edge technology to create a curated line of clean, innovative, and environmentally friendly haircare products.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:43:59.677Z",
    importedBy: "entity-db-cli",
  },
};
